/**
=========================================================
* Soft UI Dashboard React - v3.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Soft UI Dashboard React base styles
import borders from "assets/theme/base/borders";
import colors from "assets/theme/base/colors";

// Soft UI Dashboard React helper functions
import pxToRem from "assets/theme/functions/pxToRem";
import linearGradient from "assets/theme/functions/linearGradient";

const { borderWidth, borderColor } = borders;
const { transparent, gradients, info } = colors;

// const radio = {
//   styleOverrides: {
//     root: {
//       backgroundPosition: "center",
//       backgroundSize: "contain",
//       backgroundRepeat: "no-repeat",
//       width: pxToRem(20),
//       height: pxToRem(20),
//       marginRight: pxToRem(6),
//       padding: 0,
//       color: transparent.main,
//       border: `${borderWidth[1]} solid ${borderColor}`,
//       borderRadius: "50%",
//       transition: "all 250ms ease",

//       "&:hover": {
//         backgroundColor: transparent.main,
//       },

//       "& .MuiSvgIcon-root": {
//         fill: transparent.main,
//       },

//       "&.Mui-focusVisible": {
//         border: `${borderWidth[2]} solid ${info.main} !important`,
//       },
//     },

//     colorPrimary: {
//       backgroundColor: transparent.main,

//       "&.Mui-checked": {
//         backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' height='15px' width='15px'%3E%3Ccircle cx='50%' cy='50%' r='3' fill='%23fff' /%3E%3C/svg%3E"), ${linearGradient(
//           gradients.dark.main,
//           gradients.dark.state
//         )}`,
//         borderColor: gradients.dark.main,
//       },

//       "&:hover": {
//         backgroundColor: transparent.main,
//       },
//     },

//     colorSecondary: {
//       backgroundColor: transparent.main,

//       "&.Mui-checked": {
//         backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' height='15px' width='15px'%3E%3Ccircle cx='50%' cy='50%' r='3' fill='%23fff' /%3E%3C/svg%3E"), ${linearGradient(
//           gradients.dark.main,
//           gradients.dark.state
//         )}`,
//         borderColor: gradients.dark.main,
//       },

//       "&:hover": {
//         backgroundColor: transparent.main,
//       },
//     },
//   },
// };

const radio = {
  styleOverrides: {
    root: {
      width: pxToRem(25),
      height: pxToRem(25),
      marginRight: pxToRem(6),
      padding: 0,
      borderRadius: "50%",
      border: `${pxToRem(2)} solid #002D72`, // Outer blue ring
      backgroundColor: "#ffffff", // Center white
      position: "relative", // Needed for ::before
      boxSizing: "border-box",
      transition: "all 250ms ease",

      "&:hover": {
        backgroundColor: "#ffffff",
      },

      "& .MuiSvgIcon-root": {
        display: "none", // Hide default check icon
      },

      "&.Mui-focusVisible": {
        outline: `2px solid #002D72`,
      },
    },

    colorPrimary: {
      "&.Mui-checked": {
        backgroundColor: "#ffffff", // Keep center white
        borderColor: "#002D72",

        "&::before": {
          content: '""',
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: pxToRem(18),
          height: pxToRem(18),
          borderRadius: "50%",
          backgroundColor: "#075032", // Green dot
        },
      },
    },
  },
};



export default radio;
